<template>
  <div>
    <b-row class="mb-2 justify-content-between align-items-center">
      <b-col>
        <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
      </b-col>
      <b-col class="text-right">
        <b-button variant="success" @click="saveQuote">Guardar</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de la Proforma (Editable)</h4>
          </b-card-header>
          <b-card-body class="mt-1">
            <b-row>
              <b-col md="3">
                <strong>Establecimiento Origen:</strong>
                <p class="mt-1">{{ quote.establishmentOrigin ? quote.establishmentOrigin.name : 'No disponible' }}</p>
              </b-col>

              <b-col md="2">
                <b-form-group label="Documento Cliente">
                  <b-form-input v-model="quote.clientDni" placeholder="Documento del Cliente" />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Código de la proforma">
                  <b-form-input readonly v-model="quote.correlative" placeholder="Código de la proforma" />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Nombres Cliente">
                  <b-form-input v-model="quote.clientName" placeholder="Nombres Cliente" trim />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Tipo de Moneda">
                  <b-form-select v-model="quote.currencyType">
                    <b-form-select-option value="Sol">Sol</b-form-select-option>
                    <b-form-select-option value="Dólar">Dólar</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Agregar Autopartes -->
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Agregar autopartes al prestamo</h4>
          </b-card-header>
          <b-card-body class="mt-1">
            <b-row>
<b-col md="12">
                <b-form-group label="Autoparte">
                  <v-select
                    :options="autoparts"
                    label="label"
                    v-model="newItem.autopart"
                    :reduce="(autopart) => autopart"
                    placeholder="Seleccione una autoparte"
                    :filterable="true"
                    :filter-by="customFilter"
                    @input="updateQtyAvailable"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Cantidad Solicitada">
                  <b-form-input
                    v-model="newItem.qty"
                    type="number"
                    placeholder="Ingrese cantidad"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Tipos de precio">
                  <v-select
                    :options="priceOptions"
                    label="name"
                    v-model="newItem.selectedPrice"
                    :reduce="(price) => price.value"
                    placeholder="Seleccione un precio"
                    @input="updatePrice"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Precio seleccionado">
                  <b-form-input
                    v-model.number="newItem.unitPrice"
                    :class="{ 'is-invalid': newItem.unitPrice < newItem.minPrice }"
                    type="number"
                    placeholder="Ingrese precio"
                    @keydown="preventInvalidPrice"
                    @blur="enforceMinPrice"
                  />
                  <b-form-invalid-feedback v-if="newItem.unitPrice < newItem.minPrice">
                    El precio no puede ser menor al mínimo permitido ({{ newItem.minPrice }}).
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="4" md="2" class="d-flex align-items-center mt-1">
                <b-button variant="primary" @click="addRow">Agregar</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Detalles de la Proforma</h4>
          </b-card-header>
          <b-card-body>
            <b-table
              :items="quoteDetails"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="No existen detalles"
            >
              <template #cell(qty)="data">
                <b-form-input
                  v-model.number="data.item.qty"
                  type="number"
                  min="1"
                  @change="validateQty(data.item)"
                />
              </template>

              <template #cell(unitPrice)="data">
                <b-form-input
                  v-model.number="data.item.unitPrice"
                  type="number"
                  min="0.01"
                  step="0.01"
                  @change="validateUnitPrice(data.item)"
                />
              </template>

              <template #cell(actions)="data">
              <b-button
                v-if="data.item.isNew"
                size="sm"
                variant="danger"
                @click="removeRow(data.index)"
              >
                Eliminar
              </b-button>
            </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import QuoteService from "@/services/QuoteService";
import StoreService from "@/services/StoresService";
import InventoryService from "@/services/InventoryService";
import vSelect from "vue-select";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      quote: {
        establishmentOriginId: null,
        correlative: "",
        clientDni: "",
        clientName: "",
        currencyType: "",
      },

      newItem: {
        autopart: null,
        qty: null,
        qtyAvailable: 0,
        unitPrice: 0,
        selectedPrice: null,
        minPrice: 0,
      },
      categories: [],
      autoparts: [],
      quoteDetails: [],
      priceOptions: [
        { name: "Precio Tienda", value: "retailPrice" },
        { name: "Precio x Mayor", value: "wholesalePrice" },
        { name: "Precio Cliente Final", value: "clientPrice" },
      ],
      stores: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: "autopart.originalCode", label: "Código Original", sortable: true },
        { key: "autopart.AutopartBrand.name", label: "Marca", sortable: false },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: false },
        { key: "unitPrice", label: "Precio Unitario", sortable: false },
        { key: "actions", label: "Acciones", sortable: false },
      ],
    };
  },
  components: {
    vSelect,
  },
  watch: {
    "newItem.unitPrice"(value) {
      if (value < this.newItem.minPrice) {
        this.newItem.unitPrice = this.newItem.minPrice;
      }
    },

    "newItem.autopart": function (newValue) {
  this.newItem.qtyAvailable = 0;
  this.newItem.qty = null;
  this.newItem.selectedPrice = null;
  this.newItem.unitPrice = 0;
  this.newItem.minPrice = 0;

  if (newValue) {
    this.updateQtyAvailable();
  }
},

    "newItem.selectedPrice": function (newValue) {
      if (!newValue || !this.newItem.autopart) {
        this.newItem.unitPrice = 0;
        return;
      }
      const selectedPrice = parseFloat(this.newItem.autopart[newValue]);
      this.newItem.unitPrice = selectedPrice || 0;
      this.newItem.minPrice = selectedPrice || 0;
    },
  },
  mounted() {
    this.getQuoteDetails();
    this.loadStores();
  },
  methods: {
    updateQtyAvailable() {
      if (!this.newItem.autopart) {
        this.newItem.qtyAvailable = null;
        return;
      }
      this.newItem.qtyAvailable = this.newItem.autopart.qtyAvailable;
    },
    updatePrice() {
      if (!this.newItem.autopart || !this.newItem.selectedPrice) {
        this.newItem.unitPrice = 0;
        this.newItem.minPrice = 0;
        return;
      }

      const selectedPrice = parseFloat(
        this.newItem.autopart[this.newItem.selectedPrice]
      );
      this.newItem.unitPrice = selectedPrice;
      this.newItem.minPrice = selectedPrice;
    },
    preventInvalidPrice(event) {
      const newValue = parseFloat(event.target.value + event.key);
      if (newValue < this.newItem.minPrice && !isNaN(newValue)) {
        event.preventDefault();
      }
    },
    enforceMinPrice() {
      if (this.newItem.unitPrice < this.newItem.minPrice) {
        this.newItem.unitPrice = this.newItem.minPrice;
      }
    },
    async getQuoteDetails() {
      const quoteId = this.$route.params.id;
      const response = await QuoteService.getQuoteById(quoteId, this.$store);
        if (response.data) {
          this.quote = response.data.quote;
          this.quoteDetails = response.data.quoteDetails
        } 
        
        const resp = await InventoryService.getCategoryxStore(this.quote.establishmentOriginId, this.$store);
        this.categories = resp.data || [];
        await this.loadAutoparts();
    },

    async loadStores() {
      const response = await StoreService.getStores("", this.$store);
      this.stores = response.data.rows || [];
    },

    customFilter(option, label, search) {
      if (!search) return true;
      const normalizedLabel = label.toLowerCase();
      const normalizedSearch = search.toLowerCase().split(" ");
      return normalizedSearch.every((word) => normalizedLabel.includes(word));
    },

    updateQtyAvailable() {
      if (!this.newItem.autopart) {
        this.newItem.qtyAvailable = null;
        return;
      }
      this.newItem.qtyAvailable = this.newItem.autopart.qtyAvailable;
    },

    async saveQuote() {
      try {
        const quoteId = this.$route.params.id;

        const payload = {
          establishmentOriginId: this.quote.establishmentOriginId,
          correlative: this.quote.correlative,
          clientDni: this.quote.clientDni,
          clientName: this.quote.clientName,
          currencyType: this.quote.currencyType,
          state: "Cotización",
          autoparts: this.quoteDetails.map(item => ({
            autopartId: item.autopart.id,
            qty: parseInt(item.qty),
            unitPrice: parseFloat(item.unitPrice),
          })),
        };

        console.log("Payload enviado:", payload);

        const response = await QuoteService.updateQuote(quoteId, payload, this.$store);

        if (response && response.statusCode === 200) {
          await this.$swal({
            title: "Éxito",
            text: `La proforma ha sido actualizada correctamente.`,
            icon: "success",
            confirmButtonText: "Aceptar"
          });

          this.$router.push('/proforma');
        } else {
          this.$swal("Error", "No se pudo actualizar la proforma.", "error");
        }
      } catch (error) {
        console.error("Error al actualizar la proforma:", error);
        this.$swal("Error", "Ocurrió un problema al actualizar la proforma.", "error");
      }
    },

    removeRow(index) {
      this.quoteDetails.splice(index, 1);
    },

    validateQty(item) {
      if (item.qty < 1) {
        item.qty = 1;
      }
    },

    validateUnitPrice(item) {
      if (item.unitPrice < 0.01) {
        item.unitPrice = 0.01;
      }
    },

    async loadAutoparts() {
      if (!this.quote.establishmentOriginId) return;
      const response = await InventoryService.getStockxStore(
        this.quote.establishmentOriginId,
        this.$store
      );
      console.log("Autoparts response:", response);
      this.autoparts = response.data.map((item) => ({
        id: item.autopart.id,
        label: `${item.autopart.AutopartBrand.name} - ${item.autopart.originalCode} - ${item.autopart.description}`,
        uniqueCode: item.autopart.uniqueCode,
        qtyAvailable: item.qtyAvailable,
        AutopartBrand: {
          name: item.autopart.AutopartBrand.name,},
        retailPrice: item.autopart.retailPrice,
        wholesalePrice: item.autopart.wholesalePrice,
        clientPrice: item.autopart.clientPrice,
      }));
    },

    addRow() {
      if (!this.newItem.autopart || !this.newItem.qty || !this.newItem.selectedPrice ||
        this.newItem.unitPrice === 0) {
        this.$swal("Error", "Complete todos los campos antes de agregar.", "error");
        return;
      }

      if (this.quoteDetails.find((item) => item.autopart.id === this.newItem.autopart.id)) {
        this.$swal("Error", "La autoparte ya está en la lista.", "error");
        return;
      }

      this.quoteDetails.push({
        autopart: {
          id: this.newItem.autopart.id,
          uniqueCode: this.newItem.autopart.uniqueCode,
          originalCode: this.newItem.autopart.label.split(" - ")[1],
          description: this.newItem.autopart.label.split(" - ")[2],
          AutopartBrand:{
            name: this.newItem.autopart.AutopartBrand.name,
          } 
        },
        qty: this.newItem.qty,
        unitPrice: this.newItem.unitPrice,
        isNew: true, 
      });

      this.newItem = { autopart: null,
        qty: null,
        qtyAvailable: 0,
        unitPrice: 0,
        selectedPrice: null,
        minPrice: 0, };
    },
    removeRow(index) {
      this.quoteDetails.splice(index, 1);
    },
  },
};
</script>
